import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "myBookings",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.MY_BOOKINGS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.MY_BOOKINGS.PERMISSIONS,
    },
    component: () => import("@/modules/MyBookings/views/MyBookings.vue"),
  },
  {
    path: PATH.ISSUANCE_LOGS,
    name: "IssuanceLogs",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.MY_BOOKINGS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.MY_BOOKINGS.PERMISSIONS,
    },
    component: () => import("@/modules/MyBookings/views/IssuanceLogs.vue"),
  },
  {
    path: PATH.ISSUANCE_LOGS_WITHOUT_PNR,
    name: "IssuanceLogsWithoutPNR",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.ISSUANCE_LOGS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.ISSUANCE_LOGS.PERMISSIONS,
    },
    component: () => import("@/modules/MyBookings/views/IssuanceLogs.vue"),
  },
];

export default routes;
